import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { useProgramYearStore } from '@/stores/programYear';

import { isYearFreePath, YEAR_PARAM } from '../lib/year-param';

/**
 * 헤더 연도 선택 동작 — 기억(스토어)과 주소를 **함께** 바꾼다. 주소의 연도가 기억보다 우선하므로(FR-017) 한쪽만 바꾸면
 * `WorkspaceYearSync` 가 주소 값으로 되돌린다.
 *
 * - `select(year)`: 명시 선택 — 기억 + 주소 `?year=`
 * - `select(null)`: "최근 연도 자동" — 기억 해제 + 주소에서 제거(FR-016)
 */
export function useYearSelection() {
  const setExplicitYear = useProgramYearStore((s) => s.setExplicitYear);
  const clearExplicitYear = useProgramYearStore((s) => s.clearExplicitYear);
  const [, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();

  return useCallback(
    (year: null | number) => {
      if (year === null) clearExplicitYear();
      else setExplicitYear(year);
      if (isYearFreePath(pathname)) return;
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (year === null) next.delete(YEAR_PARAM);
          else next.set(YEAR_PARAM, String(year));
          return next;
        },
        { replace: true },
      );
    },
    [clearExplicitYear, pathname, setExplicitYear, setSearchParams],
  );
}
